import { autoAssignmentApi } from "@/api/autoAssignmentApi";

const actions = {
  async assignDefaultAssignee({ commit, dispatch, state }, defaultAssignee) {
    await dispatch("get");
    const configuration = state.configuration;
    configuration.defaultAssignee = defaultAssignee;
    await dispatch("put", configuration);
    commit("setAutoAssignmentConfiguration", configuration);
  },
  async create({ dispatch, state, commit }, ruleList) {
    await dispatch("get");
    commit("addRuleToConfiguration", ruleList);
    const configuration = state.configuration;
    await dispatch("put", configuration);
    commit("setAutoAssignmentConfiguration", configuration);
  },
  async get(context) {
    const response = await autoAssignmentApi.get();
    if (response.data.result?.ruleList) context.commit("setAutoAssignmentConfiguration", response.data.result);
  },
  async moveRule({ dispatch, state, commit }, payload) {
    commit("rearrangeRules", payload);
    const configuration = state.configuration;
    await dispatch("put", configuration);
  },
  async put(context, payload) {
    await autoAssignmentApi.put(payload);
  },
  async runOnDemand(context, packId: number) {
    return autoAssignmentApi.runOnDemand(packId);
  },
  async fetchRunHistory({ commit }, packId: number) {
    const response = await autoAssignmentApi.getRunHistory(packId);
    commit("setRunHistory", response.data.result);
  },
  async remove({ dispatch, state, commit }, editedIndex) {
    commit("removeFromConfiguration", editedIndex);
    const configuration = state.configuration;
    await dispatch("put", configuration);
  },
  async update({ dispatch, state, commit }, payload) {
    commit("updateConfiguration", payload);
    const configuration = state.configuration;
    await dispatch("put", configuration);
    commit("setAutoAssignmentConfiguration", configuration);
  },
};

const getters = {
  getDefaultAssignee(state) {
    return state.configuration.defaultAssignee;
  },
  getRuleList(state) {
    return state.configuration.ruleList;
  },
  getRunHistory(state) {
    return state.runHistory;
  },
};

const mutations = {
  addRuleToConfiguration(state, rule) {
    state.configuration.ruleList.push(rule);
  },
  rearrangeRules(state, payload) {
    const ruleElement = state.configuration.ruleList[payload.fromIndex];
    state.configuration.ruleList.splice(payload.fromIndex, 1);
    state.configuration.ruleList.splice(payload.toIndex, 0, ruleElement);
  },
  removeFromConfiguration(state, editedIndex) {
    state.configuration.ruleList.splice(editedIndex, 1);
  },
  setAutoAssignmentConfiguration(state, autoAssignConfig) {
    state.configuration = autoAssignConfig;
  },
  setRunHistory(state, runHistory) {
    state.runHistory = runHistory;
  },
  updateConfiguration(state, payload) {
    state.configuration.ruleList.splice(payload.editIndex, 1);
    state.configuration.ruleList.splice(payload.editIndex, 0, payload.ruleList);
  },
};

const state = {
  configuration: { defaultAssignee: null, ruleList: [] },
  runHistory: [],
};

export const autoAssignmentModule = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
